export const EQ_TYPE_CHILLER = 'Chiller';
export const EQ_TYPE_HPCHILLER = 'HeatPumpChiller';